import api from '@/api/index.js'

const account_pos_operations = {
  state: {
    loading: false,
    data: [],
    error: null
  },

  mutations: {
    SET_ACCOUNT_POS_OPERATIONS_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SSET_ACCOUNT_POS_OPERATIONS: (state, topups) => {
      state.data = topups
      state.loading = false;
    },
    SET_ACCOUNT_POS_OPERATIONS_ERROR: (state, error) => {
      state.error = error
      state.loading = false;
    }
  },

  actions: {
    ListAccountPosOperations({commit}, id) {
      commit('SET_ACCOUNT_POS_OPERATIONS_LOADING', true)
      return api.get(`accounts/${id}/pos-operations?limit=150&offset=0`)
        .then((response) => {
          commit('SSET_ACCOUNT_POS_OPERATIONS', response)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_POS_OPERATIONS_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    }
  }
}

export default account_pos_operations
